import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

const AuthTokenSync = () => {
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();

  React.useEffect(() => {
    let cancelled = false;

    const syncToken = async () => {
      if (!isAuthenticated) {
        localStorage.removeItem("access_token");
        return;
      }

      try {
        const token = await getAccessTokenSilently();
        if (!cancelled && token) {
          localStorage.setItem("access_token", token);
        }
      } catch {
        if (!cancelled) {
          localStorage.removeItem("access_token");
        }
      }
    };

    syncToken();
    return () => {
      cancelled = true;
    };
  }, [getAccessTokenSilently, isAuthenticated]);

  return null;
};

export default AuthTokenSync;
